module.exports = __webpack_public_path__ + "img/Snake.49af1e9e.png";